export default __webpack_public_path__ + "static/media/candle.3b77f2bb.jpg_small";